"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCirrusSessionId = void 0;
const useCirrus_1 = require("./useCirrus");
function useCirrusSessionId() {
    const { socket } = useCirrus_1.useCirrus();
    return socket.sessionId;
}
exports.useCirrusSessionId = useCirrusSessionId;
//# sourceMappingURL=useCirrusSessionId.js.map